export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_04.216676d3.jpg";